import { render, staticRenderFns } from "./help.vue?vue&type=template&id=5720079b&scoped=true&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5720079b",
  null
  
)

export default component.exports